import {
  Directive,
  ElementRef,
  input,
  NgZone,
  signal,
  inject,
} from '@angular/core';
import { calculateElementPosition } from '../utils/global.utils';

@Directive({
  selector: '[riResolutionUiElementDimensions]',
  standalone: true,
})
export class ElementDimensionsDirective<T> {
  private readonly el = inject(ElementRef);
  private readonly ngZone = inject(NgZone);

  // Input variables
  readonly dimensionCallback = input<(dimensions: DOMRect) => string>();

  // Signals
  private readonly _initialized = signal<boolean>(false);
  readonly initialized = this._initialized.asReadonly();

  private readonly _result = signal<T | string | null>(null);
  readonly result = this._result.asReadonly();

  constructor() {
    this.ngZone.runOutsideAngular(() => {
      calculateElementPosition(
        () => this.el,
        (domRect: DOMRect) => {
          if (domRect.top === 0) {
            return false;
          }

          if (!this.dimensionCallback()) {
            // If callback is not provided then by default directive sets height
            // of the element to gain the rest of the viewport height.
            const result = `calc(100svh - ${Math.ceil(domRect.top)}px)`;
            this.el.nativeElement.style.blockSize = result;
            this._result.set(result);
          } else {
            const result = this.dimensionCallback()!.call(this, domRect);
            this.el.nativeElement.style.blockSize = result;
            this._result.set(result);
          }

          this._initialized.set(true);

          return true;
        }
      );
    });
  }
}
